/**
 * Constants for lesson-related URLs and paths
 */
(function() {
  'use strict';

  angular.module('core').factory('lessonConstants', ['lcidConstants', function(lcidConstants) {
    return {
      LESSON_ROOT_URL: 'https://play.dreambox.com',
      LESSON_DEMO_PATH: '/student/remote_callout',
      LESSON_DEMO_BACK_PATH: '/k-8-math-lessons',

      getDemoLink: function(lessonName, gradeLevel, lcid, skin) {
        if (!lessonName) {
          return '';
        }

        lcid = lcid || lcidConstants.ENGLISH_US;
        skin = skin || '';

        return this.LESSON_ROOT_URL + this.LESSON_DEMO_PATH +
          '?try_a_lesson=' + lessonName +
          '&eng=' + gradeLevel +
          '&back=' + encodeURIComponent(this.LESSON_DEMO_BACK_PATH) +
          '&edex_demo_lesson=true&skin=' + skin +
          '&lcid=' + lcid;
      }
    };
  }]);
})();
